import { Controller } from "@hotwired/stimulus"

let chartkickLoaded = false

async function ensureChartkick() {
    if (chartkickLoaded) return
    const [{ Chart, registerables }, , ChartkickModule] = await Promise.all([
        import("chart.js"),
        import("chartjs-adapter-date-fns"),
        import("chartkick")
    ])
    Chart.register(...registerables)
    window.Chart = Chart
    const CK = ChartkickModule.default || ChartkickModule
    window.Chartkick = CK.default || CK
    chartkickLoaded = true
}

export default class extends Controller {
    static values = {
        data: Object,
        type: String, // "LineChart", "BarChart", "PieChart", etc.
        options: Object
    }

    async connect() {
        await ensureChartkick()
        this.renderChart()
    }

    renderChart() {
        const type = this.typeValue || "LineChart"
        const data = this.dataValue
        const options = this.resolveCssVars(this.optionsValue || {})

        let CK = window.Chartkick
        if (CK && !CK.LineChart && (CK.default && CK.default.LineChart)) {
            CK = CK.default
        }

        if (CK && CK[type]) {
            new CK[type](this.element, data, options)
        } else {
            console.error(`Chartkick type '${type}' not found on`, CK)
        }
    }

    // Chart.js draws on <canvas>, which can't resolve CSS custom properties,
    // so substitute var(--token) references with their computed values here.
    resolveCssVars(value) {
        if (typeof value === "string" && value.includes("var(--")) {
            const styles = getComputedStyle(this.element)
            return value.replace(/var\((--[\w-]+)\)/g, (match, name) =>
                styles.getPropertyValue(name).trim() || match)
        }
        if (Array.isArray(value)) return value.map((v) => this.resolveCssVars(v))
        if (value !== null && typeof value === "object") {
            return Object.fromEntries(
                Object.entries(value).map(([k, v]) => [k, this.resolveCssVars(v)])
            )
        }
        return value
    }
}
